import { ImagesMarketingMarketingWinBottleSignUpWebp } from '@/assets/images_marketing.assets';
import {
  Dialog,
  DialogPanel,
  Transition,
  TransitionChild,
} from '@headlessui/react';
import Image from 'next/image';
import { Fragment, useEffect, useState } from 'react';
import DefaultButton from '../common/default/DefaultButton';
import { CgClose } from 'react-icons/cg';
import useBackendUser from '@/hooks/useBackendUser';
import useTypedTranslation from '@/hooks/useTypedTranslation';
import { CommonEnum } from '@/types/translations/CommonEnum';
import { useRouter } from 'next/router';
import { deleteCookie, getCookie } from 'cookies-next';
import useRecordUserSession from '@/hooks/useRecordUserSession';
import cookiesConstants from '@/constants/cookies.constants';
export default function MarketingWinBottleSignUp() {
  const { push } = useRouter();
  const { translate } = useTypedTranslation<CommonEnum>('common');
  const { data: user, isLoading: isLoadingUser } = useBackendUser();
  const elaptedtime = useRecordUserSession();

  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    if (isLoadingUser) {
      return;
    }

    if (user) {
      return;
    }

    if (elaptedtime <= 15) {
      return;
    }

    const marketingCookie =
      getCookie(cookiesConstants.COOKIES.MARKETING_SIGN_UP.name) === 'true';

    if (marketingCookie) {
      setShowModal(true);
      deleteCookie(cookiesConstants.COOKIES.MARKETING_SIGN_UP.name);
    }
  }, [isLoadingUser, user, elaptedtime]);

  return (
    <Transition appear show={showModal} as={Fragment}>
      <Dialog
        as="div"
        className="tw-relative tw-z-[9999] max-nine:tw-p-2"
        onClose={() => setShowModal(false)}
      >
        <div className="tw-fixed tw-inset-0 tw-bg-black tw-bg-opacity-60" />

        <div className="tw-fixed tw-inset-0 tw-flex tw-items-center tw-justify-center tw-p-2 sm:tw-p-4 md:tw-p-6">
          <TransitionChild
            as={Fragment}
            enter="tw-ease-out tw-duration-300"
            enterFrom="tw-opacity-0 tw-scale-95"
            enterTo="tw-opacity-100 tw-scale-100"
            leave="tw-ease-in tw-duration-200"
            leaveFrom="tw-opacity-100 tw-scale-100"
            leaveTo="tw-opacity-0 tw-scale-95"
          >
            <DialogPanel>
              <div className="tw-w-[95%] md:tw-w-[800px] lg:tw-w-[900px] nine:tw-aspect-[3570/2400] tw-relative tw-rounded-lg tw-overflow-hidden tw-bg-white tw-shadow-xl max-nine:tw-flex max-nine:tw-flex-col-reverse nine:tw-p-12">
                <DefaultButton
                  className="
                  tw-absolute tw-top-2 tw-right-2 sm:tw-top-4 sm:tw-right-4
                  tw-bg-transparent tw-border-2 tw-border-transparent 
                  tw-p-1 sm:tw-p-2 tw-rounded-full tw-text-custom-gold 
                  tw-transition tw-duration-300 tw-shadow-none
  
                  hover:tw-bg-custom-gold hover:tw-text-white 
                  hover:tw-shadow-lg hover:tw-border-custom-gold
  
                  focus:tw-ring-2 focus:tw-ring-yellow-300 focus:tw-outline-none
  
                  active:tw-scale-90 active:tw-shadow-md
  
                  tw-disabled:tw-opacity-50 tw-disabled:tw-cursor-not-allowed
                  tw-z-50
                "
                  onClick={() => {
                    deleteCookie(
                      cookiesConstants.COOKIES.MARKETING_SIGN_UP.name
                    );

                    setShowModal(false);
                  }}
                  aria-disabled={false}
                >
                  <CgClose />
                </DefaultButton>

                <Image
                  src={ImagesMarketingMarketingWinBottleSignUpWebp}
                  alt="Marketing Win Bottle Sign Up"
                  width={3570}
                  height={2400}
                  className="tw-w-full tw-h-full tw-object-cover tw-object-center tw-absolute tw-left-0 tw-top-0 tw-z-10 max-nine:tw-relative"
                />

                <div className="max-nine:tw-bg-main max-nine:tw-w-full tw-relative tw-z-20 tw-w-2/4 tw-h-full tw-text-left tw-text-white tw-flex tw-flex-col tw-items-start tw-justify-center tw-py-12 tw-px-4">
                  <h2 className="tw-font-black tw-text-3xl sm:tw-text-4xl md:tw-text-5xl">
                    {translate(
                      CommonEnum['marketing.win_bottle_sign_up.win_this_bottle']
                    )}
                  </h2>

                  <p className="tw-font-normal tw-text-lg sm:tw-text-xl tw-border-custom-gold tw-border-solid tw-border-r-0 tw-border-l-0 tw-border-t-0 tw-pb-4">
                    {translate(
                      CommonEnum[
                        'marketing.win_bottle_sign_up.sign_up_and_participate_in_a_bottle_giveway_each_month'
                      ]
                    )}
                  </p>

                  <DefaultButton
                    className="
                      tw-bg-white tw-text-custom-gold tw-border-2 tw-border-custom-gold 
                      tw-px-6 tw-py-2 sm:tw-px-8 sm:tw-py-3 tw-rounded-full tw-font-bold tw-text-base sm:tw-text-lg 
                      tw-transition tw-duration-300 tw-shadow-md tw-w-full tw-max-w-[200px]
  
                      hover:tw-bg-custom-gold hover:tw-text-white 
                      hover:tw-shadow-lg
  
                      focus:tw-ring-2 focus:tw-ring-yellow-300 focus:tw-outline-none
  
                      active:tw-scale-95 active:tw-shadow-sm
  
                      tw-disabled:tw-bg-gray-100 tw-disabled:tw-border-gray-300 
                      tw-disabled:tw-text-gray-400 tw-disabled:tw-cursor-not-allowed 
                      tw-disabled:tw-opacity-60
                    "
                    aria-disabled={false}
                    onClick={async () => {
                      deleteCookie(
                        cookiesConstants.COOKIES.MARKETING_SIGN_UP.name
                      );
                      await push('/auth/sign-up');
                      setShowModal(false);
                    }}
                  >
                    {translate(CommonEnum['referrals.sign_up'])}
                  </DefaultButton>
                </div>
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </Dialog>
    </Transition>
  );
}
